<template>
    <div class="h-full p-[20px] flex flex-col gap-3">
        <div class="flex gap-2 items-center">
            <span :class="`${isMassLocksBlueText}` + ' default-text'">Массовые блокировки</span>
            <dx-switch v-model:value="isAllLocks" class="locks-log-switcher mx-2" />
            <span :class="`${isAllLocksBlueText}` + ' default-text ml-2'">Все блокировки</span>
        </div>
        <component :is="currentComponent" />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import MassLocksGrid from '@/views/administration/locks/mass-locks-grid.vue';
import AllLocksGrid from '@/views/administration/locks/all-locks-grid.vue';

import { DxSwitch } from 'devextreme-vue';

const currentComponent = computed(() => isAllLocks.value ? AllLocksGrid : MassLocksGrid);
const isAllLocks = ref(false);
const isMassLocksBlueText = computed(() => !isAllLocks.value ? 'blue-text' : '');
const isAllLocksBlueText = computed(() => isAllLocks.value ? 'blue-text' : '');
</script>

<style lang="scss">
.locks-log-switcher {
    height: 22px;

    .dx-switch-wrapper {
        width: 40px;

        .dx-switch-container {
            height: 22px;

            .dx-switch-inner {
                margin-left: 2px;
                width: 178%;
                height: 100%;

                .dx-switch-handle {
                    margin-top: 2px;
                }

                .dx-switch-handle::before {
                    background-color: #FFFFFF;
                    box-shadow: none;
                }
            }
        }

        .dx-switch-container::before {
            margin: 0;
            height: 22px;
            background-color: #286EB6;
        }
    }
}

.blue-text {
    color: #286EB6;
    text-shadow: 0.5px 0 0 currentColor;
}

.default-text {
    font-size: 15px;
}
</style>
